import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import {
  listBophanxuly,
  usersCanAcceptListURL,
  listVanphong,
  listBophansudung,
  ticketCreate,
  getLoaiyeucauFormURL,
  listLoaiyeucauAll,
  exportExcelTempTicket,
  importExcelFormDataTicket,
  listCustomer,
  teamListURL,
} from "../constants";
import { authAxios } from "../utils";
import {
  Form,
  Button,
  DatePicker,
  Upload,
  Spin,
  Tabs,
  notification,
} from "antd";
import { Row, Col } from "antd";
import { Select } from "antd";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import EditableTable from "./component/EditableTable";
import { Upload_Ticket_File } from "./Api";
import { openNotificationWithIcon } from "./Function";
import { UploadOutlined } from "@ant-design/icons";
import Cookies from "universal-cookie";
import { localhost } from "../server_url";
import PDFViewer from "./ViewPDF";

const cookies = new Cookies();

const { Option } = Select;
const { TabPane } = Tabs;
const layout = {
  labelCol: { span: 22, offset: 1 },
  wrapperCol: { span: 22, offset: 1 },
};

const messageBox = (type, title, contents) => {
  notification[type]({
    message: title,
    description: contents,
  });
};

const timeout = (delay) => {
  return new Promise((res) => setTimeout(res, delay));
};
const DateFormat = "YYYY-MM-DD";
const customFormat = (value) => `${value.format(DateFormat)}`;
function EndDate() {
  let startDate = new Date();
  let endDate,
    offset = 5;
  while (offset > 0) {
    endDate = new Date(startDate.setDate(startDate.getDate() + 1));
    if (endDate.getDay() !== 0 && endDate.getDay() !== 6) {
      offset--;
    }
  }
  return endDate;
}
function disabledDate(current) {
  // Can not select days before today and today
  return current && current < moment().add(-1, "days").endOf("day");
}
const validateMessages = {
  required: "Vui lòng nhập ${label}",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

const FormLayout = (data) => {
  const currentData = useSelector((state) => state.ticketData.ticketData);
  const isClone = useSelector((state) => state.ticketData.isClone);
  const [loaiyeucau, setLoaiyeucau] = useState([]);
  const [loadingSubmitForm, setLoadingSubmitForm] = useState(false);
  const [selectedFileOtherList, setSelectedFileOtherList] = useState([]);
  const [resultData, setResultData] = useState({});
  const [currentDataSource, setcurrentDataSource] = useState([]);
  const [currentColumns, setCurrentColumns] = useState([]);
  const [fileExcelDataTicket, setFileExcelDataTicket] = useState([]);
  const [form] = Form.useForm();

  const [getListTeam, setGetListTeam] = useState([]);
  const [getListBPSD, setGetListBPSD] = useState([]);

  const [getLoaiYC, setGetLoaiYC] = useState("");

  useEffect(() => {
    if (isClone) {
      authAxios(cookies.get("token"))
        .get(listLoaiyeucauAll, {
          params: {
            handling_group: currentData.handling_group,
            page_size: "1000",
            page: "1",
          },
        })
        .then((res) => {
          setLoaiyeucau(
            res.data.results.filter((item) => item.is_active == true),
          );
          data.setFileManual(currentData.ticket_type_att_file);
        });

      var list_team_sd = [];
      if (currentData.other1) {
        list_team_sd = currentData.other1.split(",").map((item) => {
          const trimmed = item.trim();
          return isNaN(trimmed) ? trimmed : Number(trimmed);
        });
      }

      form.setFieldsValue({
        subject: currentData.title,
        assigned_bophansudung: currentData.bophansudung,
        other1: list_team_sd, // 300525
        assigned_bophanxuly: currentData.handling_group,
        assigned_loaiyeucau: currentData.ticket_type,
        assigned_nguoipheduyet: currentData.approve_user,
        assigned_vanphong: currentData.vanphong,
        title: currentData.subject,
        ghichu: currentData.description,
      });

      if (currentData.data_item.dataform) {
        setCurrentColumns(currentData.data_item.dataform.original_header);
        setcurrentDataSource(currentData.data_item.dataform.data);
        setResultData(currentData.data_item);
      }
    }
  }, [isClone]);

  useEffect(() => {
    if (data.list_customer.length === 1) {
      form.setFieldsValue({
        id_cty: data.list_customer[0].id,
      });
    }

    if (data.list_vanphong.length !== 0) {
      var get_vp_ticket = form.getFieldValue("assigned_vanphong");
      if (get_vp_ticket !== undefined) {
        var filter_vp = data.list_vanphong.filter(
          (item) => item.id == get_vp_ticket,
        );

        if (filter_vp.length === 0) {
          form.setFieldsValue({
            assigned_vanphong: undefined,
          });
        }
      }
    }

    if (data.list_team) {
      const sortedListTeam = [...data.list_team].sort((a, b) => {
        if (a.name === "Tất cả") return -1;
        if (b.name === "Tất cả") return 1;
        return 0;
      });
      setGetListTeam(sortedListTeam);
    }

    if (data.list_bophansudung) {
      const sortedListBPSD = [...data.list_bophansudung].sort((a, b) => {
        if (a.name === "Tất cả") return -1;
        if (b.name === "Tất cả") return 1;
        return 0;
      });
      setGetListBPSD(sortedListBPSD);
    }
  }, [data]);

  const uploadOtherFileRequest = ({ file, onSuccess, data }) => {
    setTimeout(() => {
      onSuccess("ok");
      Upload_File_Other(file);
    }, 0);
  };

  const Upload_File_Other = (file) => {};

  const handleChangeOther = (info) => {
    let thisFileList = [...info.fileList];
    setSelectedFileOtherList(thisFileList);
    if (thisFileList.length === 0) {
      form.setFieldsValue({
        filedinhkemkhac: undefined,
      });
    }
  };

  async function waitForUpload(ticketId, fileOther) {
    if (fileOther) {
      let resultOther = await Upload_Ticket_File(ticketId, fileOther);
      return resultOther;
    }
  }

  const onFinish = async (values) => {
    await timeout(500);
    let elementsErr = document.getElementsByClassName(
      "ant-form-item-explain-error",
    );
    if (elementsErr.length !== 0) {
      return;
    }
    setLoadingSubmitForm(true);

    let resultDataFinal = {};
    if (isClone) {
      if (
        resultData &&
        resultData.dataform &&
        resultData.dataform.data &&
        resultData.dataform.data.length > 0
      ) {
        const cleanedData = resultData.dataform.data.map((row) =>
          Object.fromEntries(
            Object.entries(row).filter(
              ([key]) =>
                currentColumns[0].children
                  .map((c) => c.dataIndex)
                  .includes(key) || key === "key",
            ),
          ),
        );
        resultDataFinal = {
          dataform: {
            data: cleanedData,
            header: currentColumns,
            original_header: currentColumns,
          },
        };
      }
    } else {
      resultDataFinal = resultData;
      if (resultDataFinal && Object.entries(resultDataFinal).length !== 0) {
        for (let i = 0; i < resultData.dataform.data.length; i++) {
          delete resultDataFinal.dataform.data[i]["key"];
          const newObj = Object.assign(
            { key: i + 1 },
            { ...resultDataFinal.dataform.data[i] },
          );
          resultDataFinal.dataform.data[i] = newObj;
        }
      }
    }
    authAxios(cookies.get("token"))
      .post(ticketCreate, {
        bophansudung: values.assigned_bophansudung,
        other1: Array.isArray(values.other1) ? values.other1.join(",") : "",
        handling_group: values.assigned_bophanxuly,
        ticket_type: values.assigned_loaiyeucau,
        approve_user: values.assigned_nguoipheduyet,
        vanphong: values.assigned_vanphong,
        fore_cus: values.id_cty,
        title: values.subject,
        duedate: moment(values.ticket_duedate).format("YYYY-MM-DD"),
        ticket_status: 1,
        description: values.ghichu,
        formDataTicket: resultDataFinal,
      })
      .then((res) => {
        if (values.filedinhkemkhac) {
          waitForUpload(res.data.id, values.filedinhkemkhac.fileList).then(
            (res) => {
              window.location = "/danhsachyeucau";
            },
          );
        } else {
          window.location = "/danhsachyeucau";
        }
      })
      .catch((err) => {
        if (err.data) {
          if (err.data.description) {
            openNotificationWithIcon(
              "error",
              "Lỗi",
              "Ghi chú không được vượt quá 1000 ký tự",
            );
          } else {
            if (err.data.title) {
              openNotificationWithIcon(
                "error",
                "Lỗi",
                "Tiêu đề yêu cầu không được vượt quá 300 ký tự",
              );
            }
          }
          if (err.data.message) {
            openNotificationWithIcon("error", "Lỗi", err.data.message);
          }
        }
        setLoadingSubmitForm(false);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const onReset = () => {
    form.resetFields();
    setCurrentColumns([]);
    setcurrentDataSource([]);
  };
  const onSubmitAllRow = () => {
    let elements = document.getElementsByClassName("submitAllForm");
    if (elements && elements.length > 0) {
      for (const btn of elements) {
        btn.click();
      }
    }
  };
  const CheckSubmit = async () => {
    let CheckForm = onSubmitAllRow();
    form.submit();
  };
  const handleChange_bophanxuly = (value) => {
    setCurrentColumns([]);
    setcurrentDataSource([]);
    authAxios(cookies.get("token"))
      .get(listLoaiyeucauAll, {
        params: {
          handling_group: value,
          page_size: "1000",
          page: "1",
        },
      })
      .then((res) => {
        setLoaiyeucau(
          res.data.results.filter((item) => item.is_active == true),
        );
        form.setFieldsValue({
          assigned_loaiyeucau: "",
        });
      })
      .catch((err) => {
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };
  const getValue_IDLoaiyeucau = (value) => {
    let templateLoaiyeucauManual = loaiyeucau.filter((i) => i.id === value)[0];
    data.setFileManual(templateLoaiyeucauManual.attachment_file);
    setGetLoaiYC(templateLoaiyeucauManual);
    authAxios(cookies.get("token"))
      .get(getLoaiyeucauFormURL(value))
      .then((res) => {
        if (res.data.message === "The ticket type template does not exist") {
          setCurrentColumns([]);
          setcurrentDataSource([]);
        } else {
          setCurrentColumns([]);
          setcurrentDataSource([]);
          if (res.data.hasOwnProperty("forms")) {
            if (res.data.forms.length != 0) {
              let dataInput = res.data.forms;
              dataInput[0].children[0].fixed = "left";
              cleanData(dataInput);
            }
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };
  const getResultData = (value) => {
    let obj = {};
    let children_obj = {};
    children_obj.data = value;
    children_obj.header = currentColumns;
    obj.dataform = children_obj;
    setResultData(obj);
  };

  const cleanData = (values) => {
    try {
      let dataSource = [];
      let obj_data = {};
      let columns = [];
      for (const itemValue in values) {
        let columnsTemp = [];
        if (
          !values[itemValue].title === undefined ||
          !values[itemValue].children ||
          values[itemValue].children.length === 0
        ) {
          setCurrentColumns([]);
          setcurrentDataSource([]);
          openNotificationWithIcon(
            "error",
            "Lỗi",
            "Dữ liệu form mẫu có vấn đề, vui lòng kiểm tra lại",
          );
          return false;
        }
        for (const obj_item in values[itemValue].children) {
          let obj_column = {};
          const item = values[itemValue].children[obj_item];

          const cleanTitle = (item.title || "")
            .replace(/\s*\(\*\)\s*/g, "")
            .trim();
          let cleanValidate = item.validate;
          if (cleanValidate && typeof cleanValidate === "object") {
            cleanValidate = { ...cleanValidate };
            if (cleanValidate.target) {
              cleanValidate.target = cleanValidate.target
                .replace(/\s*\(\*\)\s*/g, "")
                .trim();
            }
          }

          obj_data[cleanTitle] = "";
          obj_column.title = cleanTitle;
          obj_column.dataIndex = cleanTitle;
          obj_column.status = item.status;
          obj_column.required = item.required;
          obj_column.type = item.type;
          obj_column.id = item.id;
          obj_column.option = item.option;
          obj_column.key = cleanTitle;
          obj_column.validate = cleanValidate;
          obj_column.handling = item.handling;
          obj_column.editable = item.editable;
          obj_column.ellipsis = false;
          obj_column.width = item.widthcol ? parseInt(item.widthcol) : 200;
          if (values[itemValue].children.length > 3) {
            obj_column.fixed = item.fixed ? true : item.fixed;
          }
          columnsTemp.push(obj_column);
        }
        columns.push({
          title: values[itemValue].title,
          editable: values[itemValue].editable,
          colortitle: values[itemValue].colortitle,
          children: columnsTemp,
        });
      }

      if (columns.length === 0) {
        setCurrentColumns([]);
        setcurrentDataSource([]);
        openNotificationWithIcon(
          "error",
          "Lỗi",
          "Dữ liệu form mẫu có vấn đề, vui lòng kiểm tra lại",
        );
      }
      dataSource.push(obj_data);
      setCurrentColumns(columns);
      setcurrentDataSource(dataSource);
    } catch (err) {
      setCurrentColumns([]);
      setcurrentDataSource([]);
      openNotificationWithIcon(
        "error",
        "Lỗi",
        "Dữ liệu form mẫu có vấn đề, vui lòng kiểm tra lại",
      );
    }
  };

  const fileDownload_TempTicket = () => {
    const fnFileDownload = require("js-file-download");
    const filename =
      getLoaiYC.slug_name +
      "_" +
      moment(new Date()).format("YYYYMMDD") +
      ".xlsx";
    var data = new FormData();
    data.append("ticket_type_id", getLoaiYC.id);
    authAxios(cookies.get("token"))
      .post(exportExcelTempTicket, data, { responseType: "blob" })
      .then((res) => {
        fnFileDownload(res.data, filename);
      });
  };

  const handleChangeUpload = ({ fileList }) => {
    setFileExcelDataTicket(fileList);
    if (fileList.length != 0) {
      const data = new FormData();
      data.append("ticket_type_id", getLoaiYC.id);
      fileList.forEach((element) => {
        if (element.originFileObj) {
          data.append("file", element.originFileObj);
        }
      });
      authAxios(cookies.get("token"))
        .post(importExcelFormDataTicket, data)
        .then((res) => {
          if (res.data.message != "success") {
            setFileExcelDataTicket([]);
            messageBox("error", "Lỗi", res.data.message);
            return;
          }
          if (
            !res.data.dataform ||
            !res.data.dataform.data ||
            res.data.dataform.data.length == 0
          ) {
            setFileExcelDataTicket([]);
            messageBox("error", "Lỗi", "Dữ liệu nhập trống.");
            return;
          }

          // Clean keys to match currentColumns and add unique row keys
          const cleanedData = res.data.dataform.data.map((row, index) => {
            const newRow = { key: row.key || row.STT || index + 1 };
            Object.keys(row).forEach((oldKey) => {
              const cleanedKey = oldKey.replace(/\s*\(\*\)\s*/g, "").trim();
              newRow[cleanedKey] = row[oldKey];
            });
            return newRow;
          });

          let ls_key = cleanedData.map((value) => value.key);
          let findDuplicates_STT = ls_key.filter(
            (item, index) =>
              ls_key.indexOf(item) != index && item !== undefined,
          );
          if (findDuplicates_STT.length > 0) {
            setFileExcelDataTicket([]);
            messageBox(
              "error",
              "Lỗi",
              "Giá trị cột STT trong file excel bị trùng. Vui lòng nhập lại.",
            );
            return;
          }

          setcurrentDataSource(cleanedData);
          getResultData(cleanedData);
          messageBox(
            "success",
            "Thành công",
            "Import dữ liệu thành công, vui lòng kiểm tra lại dữ liệu ở bảng chi tiết yêu cầu.",
          );
        })
        .catch((err) => {
          console.log(err);
          setFileExcelDataTicket([]);
          messageBox(
            "error",
            "Lỗi",
            "Không nhập được file yêu cầu. Bạn vui lòng thử lại.",
          );
        });
    }
  };

  const handleChangeSelectTeam = (value) => {
    const isAllSelected = value.includes(72);
    if (isAllSelected) {
      form.setFieldsValue({ other1: [72] });
    } else {
      form.setFieldsValue({ other1: value });
    }
  };

  return (
    <Spin spinning={loadingSubmitForm} tip="Đang tạo yêu cầu vui lòng đợi....">
      <Form
        layout={"vertical"}
        labelCol={{ span: 22, offset: 1 }}
        wrapperCol={{ span: 22, offset: 1 }}
        name="basic"
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        validateMessages={validateMessages}
        labelAlign={"left"}
      >
        <Row className={"ticket-create-form"}>
          <Col xs={22} sm={22} md={22} lg={8} xl={8}>
            <Form.Item
              label="Bộ phận xử lý"
              name="assigned_bophanxuly"
              rules={[{ required: true }]}
            >
              <Select loading={data.loading} onChange={handleChange_bophanxuly}>
                {data.list_bophanxuly.map((v) => (
                  <Option key={v.id} value={v.id}>
                    {v.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Loại yêu cầu"
              name="assigned_loaiyeucau"
              rules={[{ required: true }]}
              initialValue={[]}
            >
              <Select loading={data.loading} onChange={getValue_IDLoaiyeucau}>
                {loaiyeucau.map((v) => (
                  <Option key={v.id} value={v.id}>
                    {v.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Người phê duyệt"
              name="assigned_nguoipheduyet"
              rules={[{ required: true }]}
            >
              <Select loading={data.loading}>
                {data.list_nguoipheduyet.map((v) => (
                  <Option key={v.id} value={v.id}>
                    {v.last_name + " " + v.first_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Công ty"
              name="id_cty"
              rules={[{ required: true }]}
            >
              <Select loading={data.loading}>
                {data.list_customer.map((v) => (
                  <Option key={v.id} value={v.id}>
                    {v.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Row>
              <Col span={11} style={{ marginLeft: "2.166667%" }}>
                <Form.Item
                  label="Phòng/Department"
                  name="assigned_bophansudung"
                  rules={[{ required: true }]}
                >
                  <Select
                    loading={data.loading}
                    showSearch
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {getListBPSD.map((v) => (
                      <Option key={v.id} value={v.id}>
                        {v.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={11} offset={1}>
                <Form.Item label="Team sử dụng" name="other1">
                  <Select
                    mode="multiple"
                    loading={data.loading}
                    showSearch={true}
                    onChange={(value) => handleChangeSelectTeam(value)}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {getListTeam.map((v) => (
                      <Option key={v.id} value={v.id}>
                        {v.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label="Văn phòng"
              name="assigned_vanphong"
              rules={[{ required: true }]}
            >
              <Select loading={data.loading}>
                {data.list_vanphong.map((v) => (
                  <Option key={v.id} value={v.id}>
                    {v.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="Thời hạn mong muốn"
              name="ticket_duedate"
              rules={[{ required: true }]}
              initialValue={moment(EndDate(), customFormat)}
            >
              <DatePicker
                style={{ width: "100%" }}
                disabledDate={disabledDate}
                format={customFormat}
              />
            </Form.Item>
          </Col>
          <Col xs={22} sm={22} md={22} lg={16} xl={16}>
            <Form.Item
              label="Tiêu đề yêu cầu"
              name="subject"
              rules={[{ required: true }]}
            >
              <TextArea />
            </Form.Item>
            <Form.Item label="Ghi chú" name="ghichu">
              <TextArea autoSize={{ minRows: 2, maxRows: 6 }} />
            </Form.Item>
            <Row>
              <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                <Form.Item
                  wrapperCol={{ ...layout.wrapperCol, offset: 3 }}
                  labelCol={{ ...layout.labelCol, offset: 3 }}
                  label="File đính kèm khác"
                  name="filedinhkemkhac"
                >
                  <Upload
                    onChange={handleChangeOther}
                    fileList={selectedFileOtherList}
                    customRequest={uploadOtherFileRequest}
                    multiple
                  >
                    <Button icon={<UploadOutlined />} htmlType="button">
                      Tải lên file khác
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>
            {/*<FileDinhKem layout={layout} fileTemplateURL={fileTemplateURL} fileTemplate={fileTemplate} id_loaiyeucau={id_loaiyeucau} form={form}/>*/}
          </Col>
        </Row>
        {currentColumns.length > 0 ? (
          <>
            <span className="styleUpload">
              <label
                className="ant-form-item-required"
                style={{ float: "left", marginTop: "6px", marginLeft: "3%" }}
              >
                Chi tiết yêu cầu
              </label>
              <Button
                type={"primary"}
                danger
                className={"btnGreen"}
                style={{ marginRight: 5, float: "right" }}
                onClick={fileDownload_TempTicket}
              >
                Tải xuống file mẫu
              </Button>

              <Upload
                accept=".xlsx"
                onChange={handleChangeUpload}
                fileList={fileExcelDataTicket}
                maxCount={1}
                beforeUpload={(file) => {
                  return false;
                }}
              >
                <Button danger type="dashed" htmlType="button">
                  Tải lên file mẫu
                </Button>
              </Upload>
            </span>

            <EditableTable
              dataSource={currentDataSource}
              columns={currentColumns}
              callBackfunction={getResultData}
              isCreate={true}
              isEditing={true}
              is_roleUser={data.isProcess}
            />
          </>
        ) : (
          ""
        )}
        <Row>
          <Col sm={24}>
            <Form.Item>
              <Button type="primary" htmlType="button" onClick={CheckSubmit}>
                Tạo yêu cầu
              </Button>
              <Button
                htmlType="button"
                onClick={onReset}
                style={{ marginLeft: 20 }}
                type="primary"
                danger
              >
                Làm lại
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

class TicketCreate extends React.Component {
  state = {
    loading: false,
    error: null,
    formVisible: false,
    data: [],
    formData: {},
    list_bophanxuly: [],
    list_loaiyeucau: [],
    list_nguoipheduyet: [],
    list_vanphong: [],
    list_bophansudung: [],
    list_customer: [],
    list_team: [],
    formLoaiyeucau: [],
    bophanxuly: "",
    default: "1111",
    selected: null,
    fileManual: null,
    currentPage: 1,
  };

  componentDidMount() {
    this.setState({ loading: true });
    this.handleBophanxuly();
    this.fetchListUser();
    this.fetchBophansudung();
    this.fetchListTeam();
    this.fetchVanphong();
    this.fetchCustomer();
  }

  handleBophanxuly() {
    authAxios(cookies.get("token"))
      .get(listBophanxuly, {
        params: { is_active: true, page_size: "1000", page: "1" },
      })
      .then((res) => {
        this.setState({
          list_bophanxuly: res.data.results.filter(
            (item) => item.is_active === true,
          ),
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  }

  fetchVanphong() {
    authAxios(cookies.get("token"))
      .get(listVanphong)
      .then((res) => {
        this.setState({
          list_vanphong: res.data?.filter((item) => item.is_active === true),
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  }

  fetchCustomer() {
    authAxios(cookies.get("token"))
      .get(listCustomer)
      .then((res) => {
        this.setState({ list_customer: res.data, loading: false });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  }

  fetchBophansudung() {
    authAxios(cookies.get("token"))
      .get(listBophansudung, {
        params: { is_active: true, page: 1, page_size: 100 },
      })
      .then((res) => {
        this.setState({
          list_bophansudung: res.data.results.filter(
            (item) => item.is_active == true,
          ),
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  }

  fetchListTeam = (params = {}) => {
    authAxios(cookies.get("token"))
      .get(teamListURL, { params: params })
      .then((res) => {
        this.setState({
          list_team: res.data?.filter((item) => item.is_active === true),
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  };

  fetchListUser() {
    authAxios(cookies.get("token"))
      .get(usersCanAcceptListURL, { params: { is_active: true } })
      .then((res) => {
        this.setState({ list_nguoipheduyet: res.data, loading: false });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
        if (err.response.status === 401) {
          this.props.history.push("/login");
        }
      });
  }
  setFileManual = (url) => {
    this.setState({ fileManual: url });
  };

  handlePrevPage = () => {
    this.setState((prevState) => ({
      currentPage: Math.max(prevState.currentPage - 1, 1),
    }));
  };

  handleNextPage = () => {
    this.setState((prevState) => ({
      currentPage: prevState.currentPage + 1,
    }));
  };

  render() {
    const { fileManual, loading, handleChangeTab, currentPage } = this.state;
    return (
      <Tabs defaultActiveKey={"1"} onChange={handleChangeTab}>
        <TabPane tab="Tạo yêu cầu mới" key="1">
          <Spin spinning={loading} tip="Đang tải dữ liệu, vui lòng đợi....">
            <FormLayout
              {...this.state}
              {...this.props}
              setFileManual={(url) => this.setFileManual(url)}
            />
          </Spin>
        </TabPane>
        {fileManual && (
          <TabPane tab="Tài liệu hướng dẫn quy trình" key="5">
            <PDFViewer
              urlPDF={`${localhost}/media/${
                fileManual.toString().split("/media/")[1]
              }`}
            />
          </TabPane>
        )}
      </Tabs>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

const mapStateToProps = (state) => {
  return {
    ticketData: state.ticketData,
    isProcess: state.user.isProcess,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TicketCreate),
);
